module.exports = {"430372100":"昭山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430372.json
// module id = 1829
// module chunks = 0